<template>
    <div id="app" class="container-fluid h-100">

        <div class="row">
            <div id="nav" class="col-lg-12 d-none d-lg-block masthead-desktop" v-bind:class="{'masthead-desktop--iframe': isInIFrame}">
                <div>
                    <div class="masthead-desktop__logo">
                        <router-link to="/tasks">
                            <div class="d-block d-xl-none">
                                <img src="./assets/logo_only.png" class="logo"/>
                            </div>
                            <div class="d-none d-xl-block">
                                <img v-if="isInIFrame" src="./assets/logo_only.png" class="logo"/>
                                <img v-else src="./assets/logo_small.png" class="logo"/>
                            </div>
                        </router-link>
                    </div>
                    <ul class="masthead-desktop__nav" v-if="isAuthenticated && isOnboardingComplete">
                        <li v-if="canShowWhatsApp" ref="menuChats"
                            class="masthead-desktop__nav__chats"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'GuestChats'}">
                            <router-link to="/guest-chat">
                                <i class="fas fa-comments"></i>
                                Guest Chats
                                <div v-if="numUnreadMessages > 0">{{numUnreadMessages}}</div>
                            </router-link>
                        </li>
                        <li ref="menuTaskCalendar"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'TaskCalendar'}">
                            <router-link to="/tasks"><i class="far fa-calendar-alt"></i>Task Calendar</router-link>
                        </li>
                        <li ref="menuBookings"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'Bookings'}">
                            <router-link to="/bookings"><i class="fas fa-bed"></i>Bookings</router-link>
                        </li>
                        <li ref="menuFormsSent"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'FormsSent'}">
                            <router-link to="/forms"><i class="fab fa-wpforms"></i>Forms</router-link>
                        </li>
                        <li ref="menuAutomations"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'Automations'}">
                            <router-link to="/automations">
                                <span class="fa-stack masthead-desktop__nav__item--automations">
                                    <i class="fas fa-cog" style=""></i>
                                    <i class="far fa-clock fa-stack-1x"></i>
                                </span>
                                Automations
                            </router-link>
                        </li>
                        <li v-if="canShowWhatsApp" ref="menuWhatsAppTemplates"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'WhatsAppTemplates'}">
                            <router-link to="/whatsapp-templates"><i class="fas fa-comments"></i>Chat Templates</router-link>
                        </li>

                        <!--              <li><router-link to="/automations"><i class="fas fa-mail-bulk"></i>&plus;<i class="fas fa-cogs"></i><br/>Automations</router-link></li>-->
                        <!--              <li><router-link to="/configure-workflow"><i class="fas fa-cog"></i>Configuration</router-link></li>-->
                    </ul>
                    <div class="masthead-desktop__right-nav">
                        <template v-if="isAuthenticated && isOnboardingComplete">

                            <search ref="searchBar"></search>

                            <Alerts ref="alerts" v-bind:alerts="alerts" v-if="isAuthenticated"></Alerts>

                            <span ref="account" v-on:click.stop="toggleAccountMenu" class="nav-account"
                                  v-bind:class="{'nav-account__current-establishment' : showAccountMenu}">
                                {{establishmentAcronym}}
                                <i v-show="showAccountMenu" class="fas fa-caret-up"></i>
                                <i v-show="!showAccountMenu" class="fas fa-caret-down"></i>
                            </span>

                            <div v-if="showAccountMenu" v-on:click.stop="toggleAccountMenu"
                                 v-click-outside.stop="toggleAccountMenu" class="nav-account__popup" v-bind:class="{'nav-account__popup--iframe': isInIFrame}">
                                <ul>
                                    <li v-for="establishment in getEstablishments" v-bind:key="establishment.name"
                                        v-on:click="selectEstablishment(establishment.reference)"
                                        v-bind:class="{'nav-account__current-establishment' : isEstablishmentCurrentlySelected(establishment)}"
                                        class="nav-account__popup__link">
                                        {{establishment.name}}
                                    </li>
                                </ul>
                                <hr>
                                <ul>
                                    <li>
                                        <router-link to="/list-establishments" class="nav-account__popup__link" v-bind:class="{'nav-account__popup__link--standalone' : !canShowWhatsApp}">Configure Establishments</router-link>
                                    </li>
                                    <li v-if="hasIntegrations">
                                        <router-link to="/list-integrations" class="nav-account__popup__link">Integrations</router-link>
                                    </li>
                                </ul>
                                <hr>
                                <ul>
                                    <li>
                                        <router-link to="/account" class="nav-account__popup__link"> Account</router-link>
                                    </li>
                                    <li>
                                        <a v-if="!isInIFrame" v-on:click="showChangePasswordPopup()" class="nav-account__popup__link"> Change password</a>
                                    </li>
                                    <li>
                                        <a v-if="!isInIFrame" v-on:click="signOut()" class="nav-account__popup__sign-out nav-account__popup__link"> Sign out</a>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <div class="d-lg-none masthead-mobile">
                <div ref="mobileBurger" class="masthead-mobile__burger">
                    <Burger v-if="isAuthenticated && isOnboardingComplete"/>
                </div>
                <span class="masthead-mobile__title">
                    {{title}}
                </span>
                <template v-if="isAuthenticated && isOnboardingComplete">
                    <search ref="searchBar"></search>
                    <Alerts v-bind:alerts="alerts" v-if="isAuthenticated"/>
                </template>
            </div>
        </div>


        <Sidebar>
            <ul class="sidebar-nav" v-if="isAuthenticated && isOnboardingComplete">
                <li><img src="./assets/logo_small.png" class="logo"/></li>
                <hr>
                <li class="row" v-on:click="toggleAccountMenuMobile">
                    <div class="col-10">
                        {{establishmentNameOrAcronym}}
                        <ul v-show="showAccountMenuMobile" class="sidebar-nav-establishment-list">
                            <li v-for="establishment in getEstablishments" v-bind:key="establishment.name"
                                v-on:click="selectEstablishment(establishment.reference)"
                                v-bind:class="{'masthead-desktop__current-establishment--list-exploded' : isEstablishmentCurrentlySelected(establishment)}">
                                {{establishment.name}}
                            </li>
                        </ul>
                    </div>
                    <div class="col-2">
                        <i v-show="showAccountMenuMobile" class="fas fa-caret-up"></i>
                        <i v-show="!showAccountMenuMobile" class="fas fa-caret-down"></i>
                    </div>
                </li>
                <hr>
                <li>
                    <router-link v-if="canShowWhatsApp" to="/guest-chat"><span><i class="fas fa-comments"></i></span>Guest Chats</router-link>
                </li>
                <li>
                    <router-link to="/tasks"><span><i class="fas fa-calendar-alt"></i></span>Task Calendar</router-link>
                </li>
                <li>
                    <router-link to="/bookings"><span><i class="fas fa-bed"></i></span>Bookings</router-link>
                </li>
                <li>
                    <router-link to="/forms"><span><i class="fab fa-wpforms"></i></span>Forms</router-link>
                </li>
                <hr>
                <li>
                    <router-link to="/automations">
                        <span class="fa-stack fa-2x" style="font-size: 0.7rem;">
                            <i class="fas fa-cog fa-stack-2x" style=""></i>
                            <i class="far fa-clock fa-stack-1x" style="position: absolute; font-size: 0.8rem; top: -8px; left: 9px"></i>
                        </span>Automations
                    </router-link>
                </li>
                <li v-if="canShowWhatsApp">
                    <router-link to="/whatsapp-templates"><span><i class="fas fa-comments"></i></span>Chat Templates</router-link>
                </li>
                <hr>
                <li>
                    <router-link to="/list-establishments"><span><i class="fas fa-house-user"></i></span>Configure establishments</router-link>
                </li>
                <li v-if="hasIntegrations">
                    <router-link to="/list-integrations" class="nav-account__popup__link"><span><i class="fas fa-cogs"></i></span>Integrations</router-link>
                </li>
                <hr>
                <li>
                    <router-link to="/account" class="nav-account__popup__link"><span><i class="fas fa-user"></i></span>Account</router-link>
                </li>
                <li v-on:click="signOut()"><span><i class="fas fa-sign-out-alt"></i></span>Sign out</li>
            </ul>
        </Sidebar>

        <div class="content">
            <router-view/>
        </div>

        <confirm-dialog v-bind:message="newVersionMessage"
                        v-bind:continuePrimaryText="'Refresh'"
                        v-bind:callbackPrimaryName="'load-new-version'"
                        v-bind:hideCancelButton="true"
                        v-if="showNewVersionDialog"/>

        <change-password v-if="showChangePassword"></change-password>
    </div>
</template>

<script>
    import { getters, mutations, store } from '@/store.js';

    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";

    import ChangePassword from './components/ChangePassword.vue';
    import ConfirmDialog from './components/ConfirmDialog.vue';
    import Alerts from './components/menu/Alerts.vue';
    import Burger from './components/menu/Burger.vue';
    import Search from './components/menu/Search.vue';
    import Sidebar from './components/menu/Sidebar.vue';

    // Mixins
    import { signInMixin } from "./mixins/SignInMixin.js";
    import { updateAppMixin } from "./mixins/UpdateAppMixin";

    export default {
        mixins: [updateAppMixin, signInMixin],
        components: {Burger, Sidebar, Alerts, Search, ConfirmDialog, ChangePassword},
        data: function () {
            return {
                showAccountMenu: false,
                showAccountMenuMobile: false,
                showChangePassword: false,
                newVersionMessage: "A new version of BetterGuest is available. Please press the refresh button.",
                connectedToWebSocket: false,
                alerts: [],
                numUnreadMessages: 0,
                allowedOrigins: [],
            }
        },
        created() {
            const rawOrigins = process.env.VUE_APP_ALLOWED_ORIGINS || "";
            this.allowedOrigins = rawOrigins.split(",").map(origin => origin.trim());
        },
        computed: {
            title() {
                return store.title
            },
            usersInitials: function () {
                return getters.getUsersInitials()
            },
            isAuthenticated: function () {
                console.log('checking if authenticated')
                return getters.isAuthenticated();
            },
            isOnboardingComplete: function () {
                console.log('checking if finished signup')
                return getters.isOnboardingComplete();
            },
            getEstablishments: function () {
                return store.host.establishments;
            },
            // getAlerts: function () {
            //     console.log("Binding alerts:");
            //     console.log(store.host.alerts);
            //     return store.host.alerts;
            // },
            establishmentNameOrAcronym: function () {
                let name = getters.getCurrentEstablishment().name;
                if (name.length <= 20) {
                    return name;
                }
                return this.establishmentAcronym;
            },
            establishmentAcronym: function() {
                let name = getters.getCurrentEstablishment().name;
                let acronym = name.charAt(0);
                for (let i = name.indexOf(" "); i > 0 && i < name.length; i = name.indexOf(" ", i + 1)) {
                    if (name.charAt(i + 1) !== " ") {
                        acronym += name.charAt(i + 1);
                    }
                }
                return acronym.toUpperCase();
            },
            canShowWhatsApp: function() {
                return getters.canShowWhatsApp();
            },
            hasIntegrations: function() {
                return store.hasIntegrations;
            },
            // ----------------------------------------------------------------------------
            //
            // Embedded behaviour
            //
            // ----------------------------------------------------------------------------
            isInIFrame: function() {
                try {
                    return window.self !== window.top;
                } catch (e) {
                    return true;
                }
            },
        },
        methods: {
            isEstablishmentCurrentlySelected(establishment) {
                if (getters.isAuthenticated() && getters.isOnboardingComplete() && store.currentEstablishmentReference !== undefined) {
                    return establishment.reference == store.currentEstablishmentReference
                }
            },
            toggleAccountMenu: function () {
                this.showAccountMenu = !this.showAccountMenu
            },
            toggleAccountMenuMobile: function () {
                this.showAccountMenuMobile = !this.showAccountMenuMobile
            },
            selectEstablishment: function (reference) {
                mutations.setCurrentEstablishmentReference(reference);
                mutations.hideNav();
                this.fetchCurrentEstablishmentProviderChannels();
                this.$root.$emit('selected-establishment')
            },
            showChangePasswordPopup: function() {
                this.showChangePassword = true;
            },
            hideChangePasswordPopup: function() {
                this.showChangePassword = false;
            },
            signOut: function () {
                console.log('signing out')
                this.disconnectWebSocket();
                this.$http.post('/guest-management/v1/auth/signout'
                ).finally(response => {
                    console.log('signing out from server: ' + response);
                    this.alerts = [];
                    mutations.signOut()
                    this.$router.push({name: 'SignIn'})
                })
            },
            fetchCurrentEstablishmentProviderChannels: function () {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/external-channels', {
                    withCredentials: true
                }).then(response => {
                    let providerChannels = [];
                    if (response.data) {
                        providerChannels.push(...response.data);
                    }
                    mutations.setCurrentEstablishmentProviderChannels(providerChannels);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                })
            },
            fetchHostAlerts: function (callback) {
                console.log('Getting host alerts')
                this.$http.get('/guest-management/v1/users/' + store.host.reference + '/alerts').then(response => {
                    if (response.data) {
                        // mutations.setHostAlerts(response.data)
                        this.alerts.splice(0, this.alerts.length);
                        this.alerts.push(...response.data);
                    }
                    if (callback !== undefined) {
                        callback(response.data)
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            checkForWelcomeTour: function () {
                console.log('Checking for welcome tour')
                if (this.alerts != undefined && this.alerts.length > 0) {
                    const welcome = this.alerts.find(n => n.type === 'tour' && n.name === 'welcome')
                    if (welcome !== undefined) {
                        this.$root.$emit('show-welcome-tour')
                    }
                }
            },
            signedIn: function (setupComplete) {
                console.log('Signed in');
                this.fetchCurrentEstablishmentProviderChannels();
                this.connectWebSocket();
                if (setupComplete) {
                    this.fetchHostAlerts(this.checkForWelcomeTour);
                } else {
                    this.fetchHostAlerts();
                }
                this.getUnreadMessagesCount();
                this.checkForIntegrations();
            },
            getUnreadMessagesCount: function() {
                console.log('Checking number of unread chats')
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/unread-message-count').then(response => {
                    if (response && !isNaN(response.data)) {
                        this.numUnreadMessages = response.data;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            checkForIntegrations: function() {
                console.log('Checking for integrations')
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations').then(response => {
                    if (response.data && response.data.length > 0) {
                        mutations.setIntegrations(true);
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            // ----------------------------------------------------------------------------
            //
            // Welcome tour behaviour
            //
            // ----------------------------------------------------------------------------
            startTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                console.log("Window width: " + window.innerWidth)

                tour.addStep({
                    id: "welcome-start",
                    text: 'Welcome to BetterGuest. Take our quick welcome tour to get started',
                    buttons: [
                        {
                            text: 'Later',
                            classes: 'btn btn-secondary',
                            action: tour.cancel
                        },
                        {
                            text: 'Start',
                            classes: 'btn btn-primary',
                            action: tour.next
                        }
                    ]
                });

                if (window.innerWidth > 576) {
                    console.log('Prepping desktop tour')
                    tour.addStep({
                        id: "task-calendar",
                        text: 'This the <b>main menu</b>. On the left is your <b>Calendar</b> showing <b>Tasks</b> such as sending an Email ' +
                            'or asking a guest to fill in a Form. Most often they are created by <b>Automations</b> that run on Bookings.',
                        attachTo: {element: this.$refs.menuTaskCalendar, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                classes: 'btn btn-primary',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "bookings",
                        text: (getters.getCurrentEstablishment().provider) ? 'These are your <b>Bookings</b>, that are synchronised with your PMS' : 'A list of your Bookings',
                        attachTo: {element: this.$refs.menuBookings, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                classes: 'btn btn-primary',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "forms-sent",
                        text: 'This is a list of <b>Forms</b> that guests have been asked to fill in, along with their responses',
                        attachTo: {element: this.$refs.menuFormsSent, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "automations",
                        text: 'Here you configure your <b>Automations</b>, such as Emails and Forms. You can edit the ' +
                            'Automations you selected during sign up here.',
                        attachTo: {element: this.$refs.menuAutomations, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.next
                            }
                        ]
                    });
                } else {
                    console.log('Prepping mobile tour')
                    tour.addStep({
                        id: "forms-sent",
                        text: 'This is your main menu. From here you can see your calendar of tasks (the current view), list forms sent to guests, and sign out.',
                        attachTo: {element: this.$refs.mobileBurger, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    })
                }

                tour.on("complete", () => {
                    this.$root.$emit("tour-main-complete")
                })

                tour.start();
            },
            startAccountTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                if (window.innerWidth > 576) {
                    tour.addStep({
                        id: "account",
                        text: 'Your <b>account details and settings</b>. Configure variables to personalise communications, ' +
                            'set up your front-desk page and more',
                        attachTo: {element: this.$refs.account, on: 'top'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    });
                }

                tour.on("complete", () => {
                    this.$router.push({name: 'Automations'});
                    this.$nextTick(() => {
                        this.startAutomationsTour();
                    })
                });

                tour.start();
            },
            startAutomationsTour: function() {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                if (window.innerWidth > 576) {
                    tour.addStep({
                        id: "automations",
                        text: 'We\'ve switched to your Automations view to show you around' ,
                        attachTo: {element: this.$refs.menuAutomations, on: 'top'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    });
                }

                tour.on("complete", () => {
                    this.$root.$emit("tour-account-complete")
                })

                tour.start();
            },
            tourComplete: function () {
                const welcome = this.alerts.find(n => n.type === 'tour' && n.name === 'welcome')
                console.log(welcome)
                this.$http.put('/guest-management/v1/users/' + store.host.reference + '/alerts/' + welcome.reference + '/acknowledged')
                    .then(() => {
                        console.log('Marked tour as watched')
                    }).catch(error => {
                    console.log(error)
                })
                console.log('Tour complete. User: ')
                console.log(store.host)
            },
            // ----------------------------------------------------------------------------
            //
            // App versioning behaviour
            //
            // ----------------------------------------------------------------------------
            setupVersionChecking: function () {
                // Register listener for new version of app
                this.initVersionCheck();

                // On every route change, check for a new version
                this.$router.beforeEach((to, from, next) => {
                    this.versioningTimer.runTimersCheck();
                    next();
                });
            },
            // ----------------------------------------------------------------------------
            //
            // WebSocket behaviour
            //
            // ----------------------------------------------------------------------------
            connectWebSocket() {
                console.log("Connecting to WebSocket on server");
                this.socket = new SockJS(process.env.VUE_APP_API_BASE_URL + '/alerts');
                this.stompClient = Stomp.over(this.socket);
                this.stompClient.connect(
                    {},
                    frame => {
                        console.log("Server responded");
                        this.connectedToWebSocket = true;
                        console.log(frame);

                        this.stompClient.subscribe("/user/queue/alerts", (message) => {
                            console.log(message);
                            let updatedAlert = JSON.parse(message.body);
                            switch (updatedAlert.state) {
                                case 'ACKNOWLEDGED':
                                case 'CANCELLED':
                                    for (let i = 0; i < this.alerts.length; i++) {
                                        if (this.alerts[i].reference == updatedAlert.reference) {
                                            this.alerts.splice(i, 1);
                                            break;
                                        }
                                    }
                                    break;
                                case 'READ':
                                    break;
                                default:
                                    this.alerts.unshift(updatedAlert);
                            }
                        });
                        this.stompClient.subscribe("/user/queue/tasks", (message) => {
                            console.log("Task updated: ");
                            console.log(message);
                            let task = JSON.parse(message.body);
                            this.$root.$emit('task-updated', task);
                        });
                        this.stompClient.subscribe("/user/queue/whatsapp-templates", (message) => {
                            console.log("WhatsApp template updated: ");
                            console.log(message);
                            let template = JSON.parse(message.body);
                            this.$root.$emit('whatsapp-template-updated', template);
                        });
                        this.stompClient.subscribe("/user/queue/chats", (message) => {
                            console.log("Chat updated: ");
                            console.log(message);
                            let chat = JSON.parse(message.body);
                            this.$root.$emit('chat-updated', chat);
                        });
                        this.stompClient.subscribe("/user/queue/chat-messages", (message) => {
                            console.log("Chat message updated: ");
                            console.log(message);
                            let updatedMessage = JSON.parse(message.body);
                            this.$root.$emit('message-updated', updatedMessage);
                        });
                        this.stompClient.subscribe("/user/queue/chats-unread-message-count", (message) => {
                            console.log("Unread message count updated: ");
                            console.log(message);
                            const { establishmentReference, unreadCount, unreadChatCount } = JSON.parse(message.body);
                            if (establishmentReference && establishmentReference === store.currentEstablishmentReference && !isNaN(unreadCount)) {
                                console.log("Updating unread message count for establishment: " + establishmentReference + " to: " + unreadCount);
                                this.numUnreadMessages = unreadCount;
                                this.$root.$emit('unread-chat-count-updated', unreadChatCount );
                            }
                        });
                    },
                    error => {
                        console.log(error);
                        this.connectedToWebSocket = false;
                    }
                );
            },
            disconnectWebSocket() {
                if (this.stompClient) {
                    this.stompClient.disconnect();
                }
                this.connectedToWebSocket = false;
            },

            // ----------------------------------------------------------------------------
            //
            // Handle OSX Scrollbar behaviour
            //
            // ----------------------------------------------------------------------------
            areScrollbarsVisible: function() {
                let scrollableElem = document.createElement('div'),
                    innerElem = document.createElement('div');
                scrollableElem.style.width = '30px';
                scrollableElem.style.height = '30px';
                scrollableElem.style.overflow = 'scroll';
                scrollableElem.style.borderWidth = '0';
                innerElem.style.width = '30px';
                innerElem.style.height = '60px';
                scrollableElem.appendChild(innerElem);
                document.body.appendChild(scrollableElem); // Elements only have width if they're in the layout
                const diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
                document.body.removeChild(scrollableElem);
                return diff > 0;
            },
            // ----------------------------------------------------------------------------
            //
            // Embedded behaviour
            //
            // ----------------------------------------------------------------------------
            registerIFrameListener: function() {
                console.log('Registering iFrame listener')
                window.addEventListener('message', async (event) => {
                    console.log('Received message from parent window');
                    console.log(event);

                    const hostname = new URL(event.origin).hostname;
                    console.log('Comparing host: ' + hostname + ' to allowed origins: ' + this.allowedOrigins);
                    if (this.allowedOrigins
                            .filter(allowedOrigin => allowedOrigin === hostname || hostname.endsWith(`.${allowedOrigin}`))
                            .length > 0) {
                        console.log('Allowed origin: ' + event.origin);
                        if (event.data && event.data.type === 'login-token' && event.data.token) {
                            console.log('Token found, signing in');
                            this.signInWithToken(event.data.token);
                        } else {
                            console.log('No token found, or \'type\' missing');
                        }
                    } else {
                        console.log('Blocked origin: ' + event.origin);
                        return;
                    }
                });
            },
            askParentForLoginToken: function() {
                console.log("Asking parent for login token");
                window.parent.postMessage({type: 'request-login-token'}, process.env.VUE_APP_ORIGIN_FOR_POST_MESSAGE);
            },
        },
        mounted: async function() {
            this.setupVersionChecking();
            if (!this.areScrollbarsVisible()) {
                mutations.setForceScrollbars();
                document.body.classList.add('force-show-scrollbars');
            }

            if (this.isInIFrame)  {
                this.registerIFrameListener();
                this.askParentForLoginToken();
                // this.checkIfAuthenticated(this.askParentForLoginToken);
            } else {
                if (this.$route.path.startsWith('/reset-password')) {
                    // If the user is on the reset password page, we don't want to check if authenticated
                    // as they are not signed in yet.
                } else {
                    this.checkIfAuthenticated();
                }
            }

            // Register event listeners
            this.$root.$on('tour-search-complete', this.startAccountTour);
            this.$root.$on('tour-welcome-complete', this.tourComplete);

            this.$root.$on('load-new-version', this.refreshApp);
            this.$root.$on('show-welcome-tour', this.startTour);
            this.$root.$on('signed-in', this.signedIn);
            this.$root.$on('setup-complete', this.checkForWelcomeTour);
            this.$root.$on('finished-changing-password', this.hideChangePasswordPopup);
        },
        beforeDestroy() {
            this.$root.$off('tour-search-complete', this.startAccountTour);
            this.$root.$off('tour-welcome-complete', this.tourComplete);

            this.$root.$off('load-new-version', this.refreshApp);
            this.$root.$off('show-welcome-tour', this.startTour)
            this.$root.$off('signed-in', this.signedIn);
            this.$root.$off('setup-complete', this.checkForWelcomeTour);
            this.$root.$off('finished-changing-password', this.hideChangePasswordPopup);
        }
    }
</script>

<style lang="scss" scoped>
    @import "styles/global.scss";
</style>